import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ISession } from '../../../models/session';
import { TranslateService } from '@ngx-translate/core';
import { WizardService } from '../wizard/wizard.service';
import { FormBuilder, Validators } from '@angular/forms';
import { UsersService } from '../users/users.service';
import { first, map, flatMap, tap } from 'rxjs/operators';

@Component({
  templateUrl: './generic_login.component.html'
})
export class SessionsGenericLoginComponent implements OnInit {
  public session: ISession;
  public genericData: any;
  public form = this.fb.group({
    login: ['', Validators.required],
    password: ['', Validators.required]
  });

  constructor(
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private usersService: UsersService,
    private fb: FormBuilder,
    private router: Router
  ) {}

  ngOnInit() {
    const parentData$ = this.route.parent.data;
    parentData$
      .pipe(
        first(),
        map(route => route.data),
        flatMap((session: ISession) => {
          this.session = session;
          return this.usersService.getGenericLogin(session.id);
        }),
        tap(data => (this.genericData = data))
      )
      .subscribe();
  }

  update() {
    const data = this.form.value;
    this.usersService.updateGenericLogin(this.session, data).subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/generic_login/generic_login.component.ts